/* Roncasa — HDB BTO Brochures section.
   Section-scoped, vanilla, re-inits on shopify:section:load.

   Data shape: [{ex, base, p:[{n,c,f,t,u,b,s,ft,note}, ...]}, ...]  newest exercise first.
     n  project name      c  classification    f  brochure filename
     t  HDB town (null when the brochure does not state it)
     u  total units       b  blocks            s  storey label (null if unstated)
     ft flat types offered            note  caveat from the brochure

   Every figure comes from the project's own sales brochure. HDB does not publish a
   per-flat-type unit split in the brochure, so types are "offered", not counted. */
(function () {
  var TYPE_LABEL = {
    '2F': '2-room Flexi', '3': '3-room', '4': '4-room',
    '5': '5-room', '3G': '3Gen', 'CCA': 'Community Care'
  };
  var TYPE_ORDER = ['2F', '3', '4', '5', '3G', 'CCA'];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function commas(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function initBto(root) {
    if (!root || root.dataset.btoInit) return;
    root.dataset.btoInit = '1';

    var dataEl = root.querySelector('[data-bto-data]');
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!DATA || !DATA.length) return;

    var body = root.querySelector('[data-bto-body]');
    var empty = root.querySelector('[data-bto-empty]');
    var sum = root.querySelector('[data-bto-sum]');
    var qEl = root.querySelector('[data-bto-q]');
    var clsEl = root.querySelector('[data-bto-class]');
    var townEl = root.querySelector('[data-bto-town]');
    var typeEl = root.querySelector('[data-bto-type]');
    var exEl = root.querySelector('[data-bto-ex]');
    var tabsEl = root.querySelector('[data-bto-tabs]');
    var activeEx = DATA[0].ex;   // newest exercise first in DATA -> latest shown by default

    var ALL = [];
    DATA.forEach(function (g) { g.p.forEach(function (p) { ALL.push(p); }); });

    // Town mode: the page's own town is the filter, so the controls come off.
    var mode = root.dataset.mode === 'town' ? 'town' : 'hub';
    var scopedTown = (root.dataset.town || '').trim();
    var controls = root.querySelector('[data-bto-controls]');
    if (mode === 'town') {
      if (!scopedTown) { mode = 'hub'; }
      else if (controls) { controls.hidden = true; }
    }

    // Dropdowns are built from the data so they can never drift from the list.
    exEl.innerHTML = ['<option value="All">All exercises</option>'].concat(
      DATA.map(function (g) { return '<option value="' + esc(g.ex) + '">' + esc(g.ex) + '</option>'; })
    ).join('');
    if (root.dataset.defaultEx === 'Latest') exEl.value = DATA[0].ex;

    var towns = [];
    ALL.forEach(function (p) { if (p.t && towns.indexOf(p.t) === -1) towns.push(p.t); });
    towns.sort();
    townEl.innerHTML = ['<option value="All">All towns</option>'].concat(
      towns.map(function (t) { return '<option value="' + esc(t) + '">' + esc(t) + '</option>'; })
    ).join('');

    var types = TYPE_ORDER.filter(function (t) {
      return ALL.some(function (p) { return (p.ft || []).indexOf(t) !== -1; });
    });
    typeEl.innerHTML = ['<option value="All">Any flat type</option>'].concat(
      types.map(function (t) { return '<option value="' + t + '">' + esc(TYPE_LABEL[t] || t) + '</option>'; })
    ).join('');


    // HDB publishes supply and prices per TOWN, grouping co-launched projects —
    // and grouping them differently between the two sources. They are rendered as
    // two tables rather than joined, because joining on flat type double-counts.
    function covLabel(covers) {
      if (!covers || !covers.length) return '';
      return '<span class="cv">' + esc(covers.join(' + ')) + '</span>';
    }

    function marketHtml(tm, town) {
      var blk = tm && tm[town];
      if (!blk) return '';
      var out = '';

      var sup = (blk.supply || []).filter(function (b) { return b.rows && b.rows.length; });
      if (sup.length) {
        var rows = sup.map(function (b) {
          return b.rows.map(function (r) {
            return '<tr><td>' + esc(r[0]) + '</td><td class="n">' + commas(r[1]) +
              '</td><td>' + covLabel(b.covers) + '</td></tr>';
          }).join('');
        }).join('');
        var total = sup.reduce(function (a, b) {
          return a + b.rows.reduce(function (x, r) { return x + (r[1] || 0); }, 0); }, 0);
        out += '<div class="mkt-b"><div class="mkt-t">Flats offered by type' +
          '<span class="mkt-tot">' + commas(total) + ' total</span></div>' +
          '<table class="mkt"><thead><tr><th>Flat type</th><th class="n">Units</th><th>Project</th></tr></thead>' +
          '<tbody>' + rows + '</tbody></table></div>';
      }

      var pr = (blk.prices || []).filter(function (b) { return b.rows && b.rows.length; });
      if (pr.length) {
        var prows = pr.map(function (b) {
          return b.rows.map(function (r, i) {
            return '<tr><td>' + (i === 0 ? covLabel(b.covers) : '') + '</td><td>' + esc(r[0]) +
              '</td><td class="n">' + esc(r[1]) + '</td><td class="n">' + esc(r[2]) +
              '</td><td class="n dim">' + esc(r[3]) + '</td></tr>';
          }).join('');
        }).join('');
        out += '<div class="mkt-b"><div class="mkt-t">Launch prices</div>' +
          '<table class="mkt"><thead><tr><th>Project</th><th>Flat type</th><th class="n">From</th>' +
          '<th class="n">After grants</th><th class="n">Resale nearby</th></tr></thead>' +
          '<tbody>' + prows + '</tbody></table>' +
          '<div class="mkt-f">Starting prices as published by HDB at launch. Grant figures are ' +
          'HDB’s illustrative maximums, not a quote.</div></div>';
      }
      return out ? '<div class="mkt-wrap">' + out + '</div>' : '';
    }

    function metaLine(p) {
      var bits = [];
      if (p.t) bits.push(esc(p.t));
      if (p.u) bits.push(commas(p.u) + ' units');
      if (p.b) bits.push(p.b + (p.b === 1 ? ' block' : ' blocks'));
      if (p.s) bits.push(esc(p.s) + ' storeys');
      if (p.ft && p.ft.length) {
        bits.push(p.ft.map(function (t) { return esc(TYPE_LABEL[t] || t); }).join(', '));
      }
      var line = bits.join(' &middot; ');
      if (p.note) line += ' <span class="nb">&middot; ' + esc(p.note) + '</span>';
      return line;
    }

    function row(p, base, i) {
      var href = encodeURI(base + '/' + p.f);
      return '<a class="brow" href="' + esc(href) + '" target="_blank" rel="noopener noreferrer">' +
        '<span class="idx">' + String(i + 1).padStart(2, '0') + '</span>' +
        '<span class="bmain">' +
          '<span class="btop">' +
            '<span class="pn">' + esc(p.n) + '</span>' +
            '<span class="lead"></span>' +
            '<span class="cls ' + esc(p.c.toLowerCase()) + '">' + esc(p.c) + '</span>' +
            '<span class="pdf">PDF &#8599;</span>' +
          '</span>' +
          '<span class="meta">' + metaLine(p) + '</span>' +
        '</span>' +
        '</a>';
    }

    function render() {
      var q = (qEl.value || '').trim().toLowerCase();
      var cls = clsEl.value, town = townEl.value, type = typeEl.value;

      function matches(p) {
        if (cls !== 'All' && p.c !== cls) return false;
        if (mode === 'town') {
          if (!p.t || p.t.toLowerCase() !== scopedTown.toLowerCase()) return false;
        } else if (town !== 'All' && p.t !== town) return false;
        if (type !== 'All' && (p.ft || []).indexOf(type) === -1) return false;
        if (q && p.n.toLowerCase().indexOf(q) === -1) return false;
        return true;
      }

      // Only one launch shows at a time. Every exercise that still has projects
      // after the active filters becomes a tab; the rest fold away behind them.
      var exList = [], hitsByEx = {};
      DATA.forEach(function (g) {
        var h = g.p.filter(matches);
        if (h.length) { exList.push(g); hitsByEx[g.ex] = h; }
      });
      if (!hitsByEx[activeEx]) activeEx = exList.length ? exList[0].ex : null;

      tabsEl.innerHTML = exList.map(function (g) {
        return '<button class="bto-tab' + (g.ex === activeEx ? ' on' : '') + '" type="button" role="tab"' +
          ' aria-selected="' + (g.ex === activeEx) + '" data-ex="' + esc(g.ex) + '">' +
          esc(g.ex) + '<span class="tc">' + hitsByEx[g.ex].length + '</span></button>';
      }).join('');
      [].forEach.call(tabsEl.querySelectorAll('.bto-tab'), function (btn) {
        btn.addEventListener('click', function () { activeEx = btn.dataset.ex; render(); });
      });

      var g = null;
      for (var gi = 0; gi < exList.length; gi++) { if (exList[gi].ex === activeEx) { g = exList[gi]; break; } }
      var kept = g ? hitsByEx[activeEx] : [];

      body.innerHTML = g ? ('<div class="exg">' +
        '<div class="exg-hd"><span class="en">' + esc(g.ex) + '</span>' +
        '<span class="ec">' + kept.length + ' ' + (kept.length === 1 ? 'project' : 'projects') +
        ' &middot; ' + commas(kept.reduce(function (a, p) { return a + (p.u || 0); }, 0)) + ' units</span></div>' +
        '<div class="exg-rows">' + kept.map(function (p, i) { return row(p, g.base, i); }).join('') + '</div>' +
        (mode === 'town' ? marketHtml(g.tm, scopedTown) : '') +
        '</div>') : '';
      if (empty) empty.hidden = kept.length > 0;

      // Most towns have no BTO in a given window; an empty section on those
      // pages is just noise. Stay visible in the theme editor so it can still
      // be selected and configured.
      if (mode === 'town' && root.dataset.hideEmpty === 'true') {
        var inEditor = !!(window.Shopify && window.Shopify.designMode);
        root.hidden = !kept.length && !inEditor;
      }

      if (sum) {
        if (!kept.length) {
          sum.innerHTML = '';
        } else {
          var units = kept.reduce(function (a, p) { return a + (p.u || 0); }, 0);
          var tw = [];
          kept.forEach(function (p) { if (p.t && tw.indexOf(p.t) === -1) tw.push(p.t); });
          var byCls = { Prime: 0, Plus: 0, Standard: 0 };
          kept.forEach(function (p) { if (byCls[p.c] != null) byCls[p.c]++; });
          sum.innerHTML =
            '<span class="s1"><b>' + kept.length + '</b> ' + (kept.length === 1 ? 'project' : 'projects') + '</span>' +
            '<span class="s1"><b>' + commas(units) + '</b> units</span>' +
            (mode === 'town' ? '' :
              '<span class="s1"><b>' + tw.length + '</b> ' + (tw.length === 1 ? 'town' : 'towns') + '</span>') +
            '<span class="s2">' + byCls.Prime + ' Prime &middot; ' + byCls.Plus + ' Plus &middot; ' + byCls.Standard + ' Standard</span>';
        }
      }
    }

    qEl.addEventListener('input', render);
    [clsEl, townEl, typeEl].forEach(function (el) { el.addEventListener('change', render); });
    render();
  }

  function initAll() {
    [].forEach.call(document.querySelectorAll('[data-bto-brochures]'), initBto);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-bto-brochures]');
    if (el) { el.dataset.btoInit = ''; initBto(el); }
  });
})();
